/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { initializeGtm } from '../helpers/gtm/analytics';
import { useFeatureFlagProvider } from './featureFlagProvider';
import { useUnleash } from './unleashProvider';

/**
 * A provider created to combine multiple context wrapper components into a single component used to wrap top level app.
 */

export const GtmProvider = ({ children }: any) => {
  const { isFeatureEnabled } = useFeatureFlagProvider();
  const { unleashSessionVariants, unleashSessionId } = useUnleash();

  useEffect(() => {
    if (!isFeatureEnabled('skipGTM')) {
      initializeGtm(children, unleashSessionVariants, unleashSessionId);
    }
  }, []);

  return <>{children}</>;
};
